import React from "react";

export const SearchContentFallback = ({ children }: { children?: React.ReactNode }) => (
	<div className="flex flex-col lg:flex-row w-full h-full">
		<div className="flex items-center justify-center h-full w-full">
			<div className="text-center p-8">
				<div className="text-4xl mb-4">⚠️</div>
				<h3 className="text-lg font-semibold text-gray-900 mb-2">Search Interface Error</h3>
				<p className="text-gray-600 text-sm mb-4">
					The search interface encountered an error. Please refresh the page to try again.
				</p>
				<button
					onClick={() => window.location.reload()}
					className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
				>
					Refresh Page
				</button>
			</div>
		</div>
		{children}
	</div>
);
